var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-left"}},[_c('router-view',{staticClass:"child-view"}),(_vm.loadingShow)?_c('div',{staticClass:"main-loading"},[_c('div',{staticClass:"loadimg"})]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }